export const MEDICATION_NAME_MIN_LENGTH = 4;
export const MEDICATION_DOSAGE_MIN_LENGTH = 2;
export const MEDICATION_PHYSICIAN_NAME_MIN_LENGTH = 8;
export const MEDICATION_REASON_MIN_LENGTH = 8;

export const TREATMENT_PLAN_V3_MEDICATION_FIELD_COLUMNS = {
  medication: 3,
  dosage: 1.5,
  startDate: 1.5,
  physician: 4,
  reason: 2,
} as const;
